import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'

import Login from '../views/Auth/Login.vue'
import Auth from '../views/Auth/Auth.vue'
import Logout from '../views/Auth/Logout.vue'
import Register from '../views/Auth/Register.vue'

import Welcome from '../views/Welcome/Welcome.vue'
import LicenceExpiration from '../views/Licence/LicenceExpiration.vue'
import LicenceExpired from '../views/Licence/LicenceExpired.vue'

import ClientList from '../views/Client/ClientList.vue'
import ClientView from '../views/Client/ClientView.vue'
import ClientDashboard from '../views/Client/ClientDashboard.vue'

import InterventionList from '../views/Intervention/InterventionList.vue'
import SignIntervention from '../views/Intervention/SignIntervention.vue'

import ParametreList from '../views/Parametre/ParametreList.vue'
import TechParamList from '../views/Parametre/TechParamList.vue'
import TypeInterventionsSettings from '../views/Parametre/TypeInterventionsSettings.vue'

import ParametreSms from '../views/Parametre/ParametreSms.vue'
import ParametreSmsSuccess from '../views/Parametre/ParametreSmsSuccess.vue'
import ParametreSociete from '../views/Parametre/ParametreSociete.vue'
import ParametreTravaux from '../views/Parametre/ParametreTravaux.vue'
import ParametreTarifs from '../views/Parametre/ParametreTarifs.vue'
import ParametreConfigMessage from '../views/Parametre/ParametreConfigMessage.vue'
import ParametreCategorieAppareil from '../views/Parametre/ParametreCategorieAppareil.vue'
import ParametrePointControle from '../views/Parametre/ParametrePointControle.vue'
import ParametreMetier from '../views/Parametre/ParametreMetier.vue'
import ParametreAbonnement from '../views/Parametre/ParametreAbonnement.vue'
import ParametreAccount from '../views/Parametre/ParametreAccount.vue'

import TechToday from '../views/Tech/TechToday.vue'
import TechInterventionView from '../views/Tech/TechInterventionView.vue'
import TechAccountView from '../views/Tech/TechAccountView.vue'

import ChantierList from '../views/Chantier/ChantierList.vue'
import ChantierViewPage from '../views/Chantier/ChantierViewPage.vue'
import PlanningPage from '../views/Planning/PlanningPage.vue'

import FacturationList from '../views/Facturation/FacturationList.vue'
import StatisticsPage from '../views/Statistics/StatisticsPage.vue'
import StatisticsPremiumPage from '../views/Statistics/StatisticsPremiumPage.vue'

import Contrats from '../views/Contrats/Contrats.vue'
import AttestationEntretien from '../views/AttestationEntretien/AttestationEntretien.vue'
import CerfaList from '../views/Cerfa/CerfaList.vue'

import MessagesProgrammes from '../views/MessagesProgrammes/MessagesProgrammes.vue'

import Stock from '../views/Stock/Stock.vue'
import Bouteilles from '../views/Stock/Bouteilles.vue'
import Detecteurs from '../views/Stock/Detecteurs.vue'

import ReferencePage from '../views/Reference/ReferencePage.vue'
import NotFound from '../views/NotFound.vue'

import NewInterventionWidget from '../views/Widgets/NewInterventionWidget.vue'

// Landing
import LandingPage from '../views/Landing/LandingPage.vue'
import LandingFonctionnalites from '../views/Landing/LandingFonctionnalites.vue'
import LandingInterventions from '../views/Landing/LandingInterventions.vue'
import LandingCerfa from '../views/Landing/LandingCerfa.vue'
import LandingAppareilDocumentation from '../views/Landing/LandingAppareilDocumentation.vue'
import LandingApplicationMobile from '../views/Landing/LandingApplicationMobile.vue'
import LandingGestionClient from '../views/Landing/LandingGestionClient.vue'
import LandingPlanification from '../views/Landing/LandingPlanification.vue'
import LandingStock from '../views/Landing/LandingStock.vue'
import LandingBouteilles from '../views/Landing/LandingBouteilles.vue'
import LandingDetecteurs from '../views/Landing/LandingDetecteurs.vue'
import LandingContratEntretien from '../views/Landing/LandingContratEntretien.vue'
import LandingPortailClient from '../views/Landing/LandingPortailClient.vue'
import LandingCommunicationAutomatisee from '../views/Landing/LandingCommunicationAutomatisee.vue'
import LandingStatistiques from '../views/Landing/LandingStatistiques.vue'
import LandingExportationDonnees from '../views/Landing/LandingExportationDonnees.vue'
import LandingIntegration from '../views/Landing/LandingIntegration.vue'
import LandingTarifs from '../views/Landing/LandingTarifs.vue'
import LandingRoiCalc from '../views/Landing/LandingRoiCalc.vue'
import LandingContact from '../views/Landing/LandingContact.vue'
import LandingBlog from '../views/Landing/LandingBlog.vue'
import LandingBlogDetail from '../views/Landing/LandingBlogDetail.vue'

// Admin
import AdminDashboard from '../views/Admin/AdminDashboard.vue'
import AdminSocietes from '../views/Admin/Societes/AdminSocietes.vue'
import AdminSocietesView from '../views/Admin/Societes/AdminSocietesView.vue'
import AdminCommerciauxDashboard from '../views/Commercial/AdminCommerciauxDashboard.vue'
import AdminCommerciauxListe from '../views/Commercial/AdminCommerciauxListe.vue'
import AdminCommerciauxPaiements from '../views/Commercial/AdminCommerciauxPaiements.vue'

import AdminBlog from '../views/Admin/Blog/AdminBlog.vue'
import UploadFichier from '../views/Admin/Tools/UploadFichier.vue'

// Mobile
import MobileHome from '../views/Mobile/Home/Home.vue'
import MobileLogin from '../views/Mobile/Auth/Login.vue'
import MobileAccount from '../views/Mobile/Auth/Account.vue'
import MobileStock from '../views/Mobile/Stock/Stock.vue'
import MobileIntervention from '../views/Mobile/Intervention/Intervention.vue'
import MobileInterventionStart from '../views/Mobile/Intervention/InterventionStart.vue'
import MobileInterventionsList from '../views/Mobile/Intervention/InterventionsList.vue'



Vue.use(VueRouter)

/**
 * 🔥 CONFIG DOMAINE → APP
 */
const DOMAIN_APP_MAP = {
    'localhost:8144': 'desktop',
    'termoflow.fr': 'desktop',
    'www.termoflow.fr': 'desktop',
    'app.termoflow.fr': 'desktop',
    'localhost:8145': 'mobile',
    'mobile.termoflow.fr': 'mobile',
}

let hostname = window.location.hostname
if (hostname == 'localhost') {
    hostname += ':' + window.location.port
}
const currentApp = DOMAIN_APP_MAP[hostname] || 'desktop'

/**
 * 🧱 ROUTES
 */
const routes = [

    // Landing
    { path: '/', name: 'Landing', component: LandingPage, meta: { app: ['desktop'] } },
    { path: '/fonctionnalites', name: 'LandingFonctionnalites', component: LandingFonctionnalites, meta: { app: ['desktop'] } },
    { path: '/interventions', name: 'LandingInterventions', component: LandingInterventions, meta: { app: ['desktop'] } },
    { path: '/cerfa', name: 'LandingCerfa', component: LandingCerfa, meta: { app: ['desktop'] } },
    { path: '/appareils-documentation', name: 'LandingAppareilDocumentation', component: LandingAppareilDocumentation, meta: { app: ['desktop'] } },
    { path: '/application-mobile', name: 'LandingApplicationMobile', component: LandingApplicationMobile, meta: { app: ['desktop'] } },
    { path: '/gestion-client', name: 'LandingGestionClient', component: LandingGestionClient, meta: { app: ['desktop'] } },
    { path: '/planification', name: 'LandingPlanification', component: LandingPlanification, meta: { app: ['desktop'] } },
    { path: '/stock', name: 'LandingStock', component: LandingStock, meta: { app: ['desktop'] } },
    { path: '/bouteilles', name: 'LandingBouteilles', component: LandingBouteilles, meta: { app: ['desktop'] } },
    { path: '/detecteurs', name: 'LandingDetecteurs', component: LandingDetecteurs, meta: { app: ['desktop'] } },
    { path: '/contrats-entretien', name: 'LandingContratEntretien', component: LandingContratEntretien, meta: { app: ['desktop'] } },
    { path: '/portail-client', name: 'LandingPortailClient', component: LandingPortailClient, meta: { app: ['desktop'] } },
    { path: '/communication-automatisee', name: 'LandingCommunicationAutomatisee', component: LandingCommunicationAutomatisee, meta: { app: ['desktop'] } },
    { path: '/statistiques', name: 'LandingStatistiques', component: LandingStatistiques, meta: { app: ['desktop'] } },
    { path: '/exportation-donnees', name: 'LandingExportationDonnees', component: LandingExportationDonnees, meta: { app: ['desktop'] } },
    { path: '/integration', name: 'LandingIntegration', component: LandingIntegration, meta: { app: ['desktop'] } },
    { path: '/tarifs', name: 'LandingTarifs', component: LandingTarifs, meta: { app: ['desktop'] } },
    { path: '/roi/calculator', name: 'LandingRoiCalc', component: LandingRoiCalc, meta: { app: ['desktop'] } },
    { path: '/contact', name: 'LandingContact', component: LandingContact, meta: { app: ['desktop'] } },
    { path: '/blog', name: 'LandingBlog', component: LandingBlog, meta: { app: ['desktop'] } },
    { path: '/blog/:slug', name: 'LandingBlogDetail', component: LandingBlogDetail, meta: { app: ['desktop'] } },

    // Auth
    { path: '/login', name: 'Login', component: Login, meta: { app: ['desktop'] } },
    { path: '/app/auth', name: 'Auth', component: Auth, meta: { app: ['desktop'] } },
    { path: '/logout', name: 'Logout', component: Logout, meta: { app: ['desktop', 'mobile'] } },
    { path: '/register', name: 'Register', component: Register, meta: { app: ['desktop'] } },

    // Public
    { path: '/sign-intervention/:token', name: 'SignIntervention', component: SignIntervention, meta: { app: ['desktop'] } },
    { path: '/c/:token', name: 'ClientDashboard', component: ClientDashboard, meta: { app: ['desktop'] } },

    // App
    { path: '/app', name: 'Home', component: Home, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/welcome', name: 'Welcome', component: Welcome, meta: { app: ['desktop'] } },

    { path: '/app/licence-expiration', name: 'LicenceExpiration', component: LicenceExpiration, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/licence-expired', name: 'LicenceExpired', component: LicenceExpired, meta: { auth: true, app: ['desktop', 'mobile'] } },

    { path: '/app/clients', name: 'ClientList', component: ClientList, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/clients/:id', name: 'ClientView', component: ClientView, meta: { auth: true, app: ['desktop'] } },

    { path: '/app/interventions', name: 'InterventionList', component: InterventionList, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/chantiers', name: 'ChantierList', component: ChantierList, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/chantiers/:id', name: 'ChantierViewPage', component: ChantierViewPage, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/facturations', name: 'FacturationList', component: FacturationList, meta: { auth: true, app: ['desktop'] } },

    { path: '/app/parametres', name: 'ParametreList', component: ParametreList, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/parametres/tech', name: 'TechParamList', component: TechParamList, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/parametres/societe', name: 'ParametreSociete', component: ParametreSociete, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/parametres/travaux', name: 'ParametreTravaux', component: ParametreTravaux, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/parametres/sms', name: 'ParametreSms', component: ParametreSms, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/parametres/sms/success', name: 'ParametreSmsSuccess', component: ParametreSmsSuccess, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/parametres/tarifs', name: 'ParametreTarifs', component: ParametreTarifs, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/parametres/config-message', name: 'ParametreConfigMessage', component: ParametreConfigMessage, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/parametres/categorie-appareil', name: 'ParametreCategorieAppareil', component: ParametreCategorieAppareil, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/parametres/point-controle', name: 'ParametrePointControle', component: ParametrePointControle, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/parametres/metier', name: 'ParametreMetier', component: ParametreMetier, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/parametres/abonnement', name: 'ParametreAbonnement', component: ParametreAbonnement, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/parametres/account', name: 'ParametreAccount', component: ParametreAccount, meta: { auth: true, app: ['desktop'] } },

    { path: '/app/statistiques', name: 'Statistiques', component: StatisticsPage, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/statistiques-premium', name: 'StatistiquesPremium', component: StatisticsPremiumPage, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/references', name: 'References', component: ReferencePage, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/planning', name: 'Planning', component: PlanningPage, meta: { auth: true, app: ['desktop'] } },

    { path: '/app/type-interventions/configuration', name: 'TypeInterventionsSettings', component: TypeInterventionsSettings, meta: { auth: true, app: ['desktop'] } },

    { path: '/app/messages-programmes', name: 'MessagesProgrammes', component: MessagesProgrammes, meta: { auth: true, app: ['desktop'] } },

    { path: '/app/stock', name: 'Stock', component: Stock, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/bouteilles', name: 'Bouteilles', component: Bouteilles, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/detecteurs', name: 'Detecteurs', component: Detecteurs, meta: { auth: true, app: ['desktop'] } },

    { path: '/app/contrats', name: 'Contrats', component: Contrats, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/cerfa', name: 'CerfaList', component: CerfaList, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/attestation-entretiens', name: 'AttestationEntretienList', component: AttestationEntretien, meta: { auth: true, app: ['desktop'] } },

    // Tech
    { path: '/app/tech/today', name: 'TechToday', component: TechToday, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/tech/intervention/:id', name: 'TechInterventionView', component: TechInterventionView, meta: { auth: true, app: ['desktop'] } },
    { path: '/app/tech/account', name: 'TechAccountView', component: TechAccountView, meta: { auth: true, app: ['desktop'] } },

    // Widget
    { path: '/app/widget/new-intervention', name: 'NewInterventionWidget', component: NewInterventionWidget, meta: { auth: true, app: ['desktop', 'mobile'] } },

    // Admin
    { path: '/admin', name: 'AdminDashboard', component: AdminDashboard, meta: { auth: true, app: ['desktop'] } },
    { path: '/admin/societes', name: 'AdminSocietes', component: AdminSocietes, meta: { auth: true, app: ['desktop'] } },
    { path: '/admin/societes/:id', name: 'AdminSocietesView', component: AdminSocietesView, meta: { auth: true, app: ['desktop'] } },

    { path: '/admin/commerciaux', name: 'AdminCommerciauxDashboard', component: AdminCommerciauxDashboard, meta: { app: ['desktop'] } },
    { path: '/admin/commerciaux/liste', name: 'AdminCommerciauxListe', component: AdminCommerciauxListe, meta: { app: ['desktop'] } },
    { path: '/admin/commerciaux/paiements', name: 'AdminCommerciauxPaiements', component: AdminCommerciauxPaiements, meta: { app: ['desktop'] } },

    { path: '/admin/blog', name: 'AdminBlog', component: AdminBlog, meta: { app: ['desktop'] } },

    { path: '/admin/upload-fichier', name: 'UploadFichier', component: UploadFichier, meta: { app: ['desktop'] } },

    /* ----------------------------------------------- */
    /* Mobile routes (not accessible on desktop)       */
    /* ----------------------------------------------- */

    { path: '/', name: 'MobileHome', component: MobileHome, meta: { auth: true, app: ['mobile'] } },
    { path: '/login', name: 'MobileLogin', component: MobileLogin, meta: { app: ['mobile'] } },
    { path: '/stock-mobile', name: 'MobileStock', component: MobileStock, meta: { app: ['mobile'] } },
    { path: '/profil', name: 'MobileAccount', component: MobileAccount, meta: { auth: true, app: ['mobile'] } },
    { path: '/intervention/:id', name: 'MobileInterventionStart', component: MobileInterventionStart, meta: { auth: true, app: ['mobile'] } },
    { path: '/chantier/:chantierId/list', name: 'MobileInterventionsList', component: MobileInterventionsList, meta: { auth: true, app: ['mobile'] } },

    // 404
    { path: '*', name: 'NotFound', component: NotFound, meta: { app: ['desktop', 'mobile'] } }
]

/**
 * 🔥 FILTRAGE DES ROUTES
 */
const filteredRoutes = routes.filter(route => {
    if (!route.meta || !route.meta.app) return true
    return route.meta.app.includes(currentApp)
})

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: filteredRoutes
})

/**
 * 🔐 AUTH
 */
router.beforeEach((to, from, next) => {
    let token = sessionStorage.getItem('auth-token') || localStorage.getItem('auth-token')
    const isAuthenticated = token != null

    if (to.meta.auth && !isAuthenticated) {
        alert('Vous devez être connecté pour accéder à cette page.')
        return next('/login')
    }

    next()
})

router.afterEach(() => {
    window.scrollTo(0, 0)
})

export default router